<template>
  <div>
    <v-btn @click="formularioUsuario()" class="mx-2" fab dark small color="darkGrey">
      <v-icon color="white" dark>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      @keydown.esc="cancelar()"
      @keydown.enter="gerenciar()"
    >
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="11">
              <span class="headline">{{tituloCorretoDoPopUp}}</span>
            </v-col>
            <v-col cols="1">
              <v-icon color="black" @click="dialog = false">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col md="12" xs="12" sm="12" v-if="$route.name == 'Usuarios'">
                  <v-autocomplete
                    v-model="usuario.idDoCliente"
                    label="Cliente"
                    :disabled="$route.query.id != undefined || bloquearSelecaoDeCliente"
                    :rules="campoObrigatorioRules"
                    no-data-text="Sem itens"
                    :items="listaClientes"
                    required
                    item-text="nome"
                    item-value="id"
                    id="cliente"
                    validate-on-blur
                  ></v-autocomplete>
                </v-col>

                <v-col md="12" xs="12" sm="12">
                  <v-text-field
                    v-model="usuario.nome"
                    label="Nome"
                    :rules="campoObrigatorioRules"
                    id="nome"
                    required
                    validate-on-blur
                  ></v-text-field>
                </v-col>

                <v-col md="12" xs="12" sm="12">
                  <v-autocomplete
                    v-model="usuario.papel"
                    label="Papel"
                    :rules="campoObrigatorioRules"
                    no-data-text="Sem itens"
                    :items="listaPapeis"
                    required
                    item-text="nome"
                    item-value="valor"
                  ></v-autocomplete>
                </v-col>

                <v-col md="12" xs="12" sm="12" class="px-2 py-0">
                  <v-switch
                    v-model="usuario.loginGoogle"
                    class="mt-0"
                    label="Login com google"
                    @change="ativarLoginComGoogle()"
                  >
                    <template v-slot:label>
                      <span>
                        Login com
                        <span class="google">Google</span>
                      </span>
                    </template>
                  </v-switch>
                </v-col>

                <v-col md="12" xs="12" sm="12" class="pt-0">
                  <v-text-field v-model="usuario.email" label="E-mail" :rules="emailRules" required></v-text-field>
                </v-col>

                <v-col md="12" xs="12" sm="12" v-if="!usuario.loginGoogle && requisicao !== 'PUT'">
                   <v-text-field
                    v-model="usuario.senha"
                    :append-icon="mostrarSenha ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="mostrarSenha ? 'text' : 'password'"
                    label="Senha"
                    :rules="senhaRules"
                    required
                    @click:append="mostrarSenha = !mostrarSenha"
                  ></v-text-field>
                </v-col>

                <v-col md="12" xs="12" sm="12" v-if="!usuario.loginGoogle && requisicao == 'PUT'" class="pt-0">
                  <div>
                    <v-card-actions class="pl-0 pr-0">
                      <v-card-text 
                        class="pl-0 abrir-campo-senha"
                        @click="show = !show"
                        >click para editar sua senha</v-card-text>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="show = !show" class="">
                        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-btn>
                    </v-card-actions>

                    <v-expand-transition>
                      <div v-show="show">
                        <v-text-field
                          v-if="!usuario.loginGoogle"
                          v-model="usuario.senha"
                          :append-icon="mostrarSenha ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="mostrarSenha ? 'text' : 'password'"
                          label="Crie uma nova senha"
                          :rules="senhaRules"
                          required
                          @click:append="mostrarSenha = !mostrarSenha">
                        </v-text-field>
                      </div>
                    </v-expand-transition>
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="6" class="text-start">
                      <v-btn
                        @click="cancelar()"
                        :disabled="carregando"
                        tile
                        color="error">
                        Cancelar
                      </v-btn>
                    </v-col>
                    <v-col cols="6" class="text-end">
                      <v-btn
                        @click="gerenciar()"
                        min-width="90"
                        :loading="carregando"
                        tile
                        color="primary"
                      >Salvar</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { enviar, editar } from "../../mixins/RequisicaoMixin.js";
import { headersPadrao } from "../../mixins/HeadersMixin.js";
import { senhasInvalidas } from "../../mixins/validacaoFormularioMixin.js";

export default {
  props: {
    usuarioEditado: {
      type: Object
    },
    urlPost: {
      type: String,
      default: ""
    },
    listaClientes: {
      default: []
    }
  },
  data() {
    return {
      show: false,
      mostrarSenha: false,
      mostrarCampoSenha: false,
      requisicao: "POST",
      mostrarCampoLoginComGoogle: true,
      usuario: {
        email: "",
        nome: "",
        papel: "",
        senha: "",
        loginGoogle: true
      },
      campoObrigatorioRules: [nome => !!nome || "Este campo é obrigatório."],
      emailRules: [
        v => !!v || "campo e-mail é obrigatório",
        v => /.+@.+\..+/.test(v) || "email é inválido"
      ],
      senhaRules: [senha => (senha = this.validarSenha(senha))],
      selectUsuario: ["Ativo", "Inativo"],
      selectPerfil: ["Administrador", "Revendedor"],
      dialog: false,
      carregando: false
    };
  },
  created() {
    this.retornaIdDoCliente(this.$route.query.id);
  },
  methods: {
    formularioUsuario() {
      this.dialog = true; //abrir modal

      //Mostar o campo senha na hora de editar ou adicionar
      this.mostrarCampoSenha = false;

      //Mostar switch para o usuario escolher se deseja logar com google ou email/senha
      this.mostrarCampoLoginComGoogle = true;

      this.mudarFocoDoComponente();
    },
    mudarFocoDoComponente() {
      setTimeout(() => {
        if (
          this.$route.name == "Multiedro" ||
          this.$route.query.id != undefined
        )
          document.getElementById("nome").focus();
        else document.getElementById("cliente").focus();
      }, 50);
    },
    salvarUsuario() {
      const cabecalho = headersPadrao();
      let novoUsuario = {
        email: this.usuario.email,
        nome: this.usuario.nome,
        papel: this.usuario.papel,
        senha: this.usuario.senha,
        ehLoginGoogle: this.usuario.loginGoogle
      };
      if (this.$route.name != "Multiedro") {
        if (this.$route.query.id == undefined)
          novoUsuario.idDoCliente = this.usuario.idDoCliente;
        else novoUsuario.idDoCliente = this.$route.query.id;
      }
      enviar(this.urlPost, cabecalho, novoUsuario)
        .then(resposta => {
          this.$emit("carregarDados", resposta);
          this.$store.commit("sucesso", "Usuário salvo com sucesso.");
          this.limparCampos();
        })
        .catch(error => {
          if (error.request.status == 409) this.$store.commit("erro", "Este e-mail já está em uso.");
          else if (error.request.status == 400) this.$store.commit("erro", "Erro ao salvar usuário. Verifique se todos os campos estão preenchido.");
          else this.$store.commit("erro", "Erro ao salvar o usuário.")
          
        })
        .finally(() => {
          this.carregando = false;
        });
    },
    editarDadosUsuarios(item) {
      
      this.mostrarSenha = false;
      this.recarregar = true;
      const urlEditarUsuario = `${this.urlPost}/${item.id}`;
      const cabecalho = headersPadrao();
      this.show = false;

      const editarUsuario = {
        email: item.email,
        idDoCliente: item.idDoCliente,
        nome: item.nome,
        papel: item.papel,
        senha: item.senha,
        ehLoginGoogle: item.loginGoogle
      };
      editar(urlEditarUsuario, cabecalho, editarUsuario)
        .then(() => {
          this.$emit("carregarDados", false);
          this.$store.commit("sucesso", "Usuário salvo com sucesso.");
          this.limparCampos();
          this.requisicao = "POST";
        })
        .catch(erro => {
          if (erro.request.status == 409) this.$store.commit("erro", "Este e-mail já está em uso.");
          else if (erro.request.status == 400) this.$store.commit("erro", "Erro ao editar usuário. Verifique se todos os campos estão preenchido.");
          else this.$store.commit("erro", "Erro ao atualizar o usuário.")
        })
        .finally(() => (this.carregando = false));

    },
    validarSenha(senha) {
      if (this.requisicao !== "PUT") {
        if (senha.length < 6) {
          return "A senha tem que ter pelo menos 6 caracteres";
        }
      }
      const senhaEhFacil = senhasInvalidas(senha);
      if (senhaEhFacil === false) {
        return "A senha é muito fácil";
      }
      return true;
    },
    requisicaoPost() {
      if (this.$route.name === "Multiedro") {
        this.salvarUsuario(this.usuario);
      }
      if (this.$route.name === "Usuarios") {
        this.salvarUsuario(this.usuario);
      }
      return this.usuario;
    },
    gerenciar() {
      if (this.$refs.form.validate()) {
        this.carregando = true;
        if (this.requisicao === "PUT") this.editarDadosUsuarios(this.usuario);
        else this.requisicaoPost();
      }
    },
    limparCampos() {
      this.dialog = false;
      this.usuario = {
        email: "",
        nome: "",
        papel: "",
        senha: "",
        loginGoogle: true
      };
      this.mostrarCampoSenha = true;
      this.requisicao = "POST";
      this.$refs.form.resetValidation();
      this.retornaIdDoCliente(this.$route.query.id);
    },
    retornaIdDoCliente(idDoCliente) {
      if (idDoCliente != undefined) {
        this.usuario.idDoCliente = idDoCliente;
      }
    },

    ativarLoginComGoogle() {
      if (this.usuario.loginGoogle) {
        this.mostrarCampoSenha = false;
        //Limpa a senha do usuario
        this.usuario.senha = "";
        return false;
      }
      this.mostrarCampoSenha = true;
      //Limpa a senha do usuario
      this.usuario.senha = "";
      return true;
    },
    cancelar(){
      this.dialog = false;
      this.show = false;
      this.limparCampos();
    }
  },
  computed: {
    listaPapeis() {
      let papeis = this.$store.state.listaPapeis.filter(p => {
        let filtroPorPagina =
          p.valor != "SUPERADMINISTRADOR" && p.valor != "REVENDEDOR";

        if (this.$route.name == "Multiedro") {
          filtroPorPagina =
            p.valor == "SUPERADMINISTRADOR" || p.valor == "REVENDEDOR";
        }
        return filtroPorPagina;
      });

      return papeis;
    },
    bloquearSelecaoDeCliente(){
      var idDoCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente
      if(idDoCliente != null) {
        this.retornaIdDoCliente(idDoCliente);
        return true
      }
      else return false
    },
    tituloCorretoDoPopUp(){
      if(this.usuario.id) return "Editar Usuário"
      else return "Novo Usuário"
    }
  },
  watch: {
    usuarioEditado(newVal) {
      this.usuario = newVal;
      this.usuario.senha = "";
      this.requisicao = "PUT";
      this.mostrarCampoSenha = false;
      this.dialog = true;
      this.mostrarCampoLoginComGoogle = false;
      this.mudarFocoDoComponente();
    },
    //limpar os campos, antes de abrir o modal
    dialog(newVal) {
      if (!newVal) this.limparCampos();
    }
  }
};
</script>

<style lang="css" scoped>
.google {
  font-weight: bold;
}

.abrir-campo-senha{
  cursor: pointer;

}
</style>

